import React from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import SingleHeadingText from "../TocHeader/SingleHeadingText";
import TocStockHeader from "../TocHeader/TocStockHeader";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import ChartIq from "@frameworks/web/components/features/Markets/Equity/MarketToday/chartIq/ChartIq";
const ChartIQTOC = (props) => {
    const device = DeviceContext();
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Chart" }) }),
        React.createElement("div", { className: "chartiqToc common-drawer-scroll" },
            React.createElement(ChartIq, { symbol: props === null || props === void 0 ? void 0 : props.symbol, instru: props === null || props === void 0 ? void 0 : props.instru })),
        React.createElement("div", { className: "toc-close-button" },
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", className: "w-100", value: "Close", onClick: () => props === null || props === void 0 ? void 0 : props.goBack() })))) : (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Chart" }) }),
        React.createElement("div", { className: "chartiqToc-mob" },
            React.createElement(ChartIq, { symbol: props === null || props === void 0 ? void 0 : props.symbol, instru: props === null || props === void 0 ? void 0 : props.instru })),
        React.createElement("div", { className: "toc-close-button" },
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", className: "w-100", value: "Close", onClick: () => props === null || props === void 0 ? void 0 : props.goBack() })))
    // <GenericDrawer
    //   show={props.show}
    //   setShow={props?.goBack}
    //   headerComp={
    //     <>
    //       <label className="term-heading DMSan_16_700 txt_blackOne1">
    //         Chart
    //       </label>
    //     </>
    //   }
    //   bodyComp={
    //     <>
    //       <div className="chartiqouterclass">
    //         <ChartIq symbol={props?.symbol}></ChartIq>
    //       </div>
    //       <div className="toc-close-button">
    //         <EdButton
    //           btnTyp="midnight-blue-border"
    //           value={"Close"}
    //           className="w-100"
    //           onClick={() => props?.goBack()}
    //         />
    //       </div>
    //     </>
    //   }
    // ></GenericDrawer>
    )));
};
export default ChartIQTOC;
